import {BaseService} from './Core/BaseService';

class ConservationActionStatisticService extends BaseService {
    get Url() { return super.Url + "/conservationActionStatistics"; }

    GetStats(conservationActionId) {
        return this.SendRequest(BaseService.GET, conservationActionId);
    }
}

export const service = new ConservationActionStatisticService();

